import { useResultActionInteractiveResult } from '../context/ResultActionAnalyticsContext';
import React from 'react';

export const InteractiveResultWithActionLink = ({
  engine,
  result,
  actionName,
  onActivated,
  children,
  ariaLabel,
  className,
  href,
  target,
  download
}) => {
  const { select, beginDelayedSelect, cancelPendingSelect } =
    useResultActionInteractiveResult({
      engine,
      result,
      actionName
    });

  return (
    <a
      href={href}
      onContextMenu={select}
      onClick={e => {
        select();
        if (onActivated) {
          onActivated(e);
        }
      }}
      onMouseUp={select}
      onMouseDown={select}
      onTouchStart={beginDelayedSelect}
      onTouchEnd={cancelPendingSelect}
      aria-label={ariaLabel ? ariaLabel : ''}
      className={className ? className : ''}
      target={target ? target : '_self'}
      download={download ? download : false}
    >
      {children}
    </a>
  );
};

export const InteractiveResultWithActionButton = ({
  engine,
  result,
  actionName,
  onActivated,
  children,
  ariaLabel,
  className,
  dataDocName,
  dataDocTech,
  dataDocType,
  dataDocUrl
}) => {
  const { select, beginDelayedSelect, cancelPendingSelect } =
    useResultActionInteractiveResult({
      engine,
      result,
      actionName
    });

  return (
    <button
      onContextMenu={select}
      onClick={e => {
        select();
        onActivated(e);
      }}
      onMouseUp={select}
      onMouseDown={select}
      onTouchStart={beginDelayedSelect}
      onTouchEnd={cancelPendingSelect}
      aria-label={ariaLabel ? ariaLabel : ''}
      className={className ? className : ''}
      data-doc-name={dataDocName ? dataDocName : ''}
      data-doc-tech={dataDocTech ? dataDocTech : ''}
      data-doc-type={dataDocType ? dataDocType : ''}
      data-doc-url={dataDocUrl ? dataDocUrl : ''}
    >
      {children}
    </button>
  );
};
